module.exports = __webpack_public_path__ + "static/media/intro.83f4213c.svg";